import { jsx } from 'react/jsx-runtime';
import { composeEventHandlers } from '@radix-ui/primitive';
import { Primitive } from '@radix-ui/react-primitive';
import { forwardRef } from 'react';
import { useFileUploadContext } from '../../context.mjs';

const FileUploadTrigger = forwardRef(({ disabled: disabledFromProps, onClick, ...props }, forwardedRef) => {
  const { disabled: disabledFromContext, inputElement } = useFileUploadContext("FileUpload.Trigger");
  const disabled = disabledFromProps ?? disabledFromContext;
  const handleClick = composeEventHandlers(onClick, (event) => {
    if (disabled) {
      return;
    }
    if (event.isDefaultPrevented()) {
      return;
    }
    inputElement?.click();
  });
  return /* @__PURE__ */ jsx(
    Primitive.button,
    {
      "data-scope": "file-upload",
      "data-part": "trigger",
      disabled,
      type: "button",
      onClick: handleClick,
      ref: forwardedRef,
      ...props
    }
  );
});
FileUploadTrigger.displayName = "FileUpload.Trigger";

export { FileUploadTrigger };
//# sourceMappingURL=Trigger.mjs.map
